import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/architect/run/$runId')({

}).lazy(() => import('./$runId.lazy').then((d) => d.Route));
